
export { buildStaffTrainingRecord } from "../../../../functions/functions-common/agents/agents/generateTrainingCourse/schema.mjs";

const dropdownData = [{
    "id": "Design",
    "label": "Design"
}, {
    "id": "Certification",
    "label": "Certification"
}, {
    "id": "Project Management",
    "label": "Project Management"
}, {
    "id": "Design certification",
    "label": "Design certification"
}, {
    "id": "Other",
    "label": "Other"
}];

const fields = [{
    "label": "Date Start",
    "name": "Date[Start]",
    "type": "date"
}, {
    "label": "Date Completed",
    "name": "Date[Complete]",
    "type": "date"
}, {
    "label": "Type",
    "name": "Type",
    "type": "dropdown",
    "dropdownData": dropdownData
}, {
    "type": "text",
    "label": "Approved By",
    "name": "ApprovedBy"
}, {
    "label": "Training / Achievement / Experience",
    "name": "Training",
    "type": "text",
    "divClass": "md:col-span-2"
}, {
    "label": "Outcomes / Comments",
    "name": "Outcomes",
    "type": "text",
    "divClass": "md:col-span-3"
}, {
    "label": "Certificate / Proof",
    "name": "Certificate",
    "type": "file",
    "required": false,
    "divClass": "md:col-span-2"
}];

export const addRecord = ({ form, router, store, db }) => {
    const date = (new Date()).toISOString();
    form.setConfig({
        "title": "Add New Training Record",
        "type": "push",
        "description": `Userdata/${router?.currentRoute?.value?.params.id}/Training/Records`,
        "location": `Userdata/${router?.currentRoute?.value?.params.id}/Training/Records`,
        "fields": fields,
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                if (!file[0]) continue;
                await db.upload(`StaffTrainingRecords/${router?.currentRoute?.value?.params.id}/${typeRef.key}`, file[0]);
                await db.update(`Userdata/${router?.currentRoute?.value?.params.id}/Training/Records/${typeRef.key}`, {
                    "Certificate": file[0].name,
                    "AddedBy": store.getters.userID,
                })
            };
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const addTrainingMaterialMulti = ({ form, store, db, selectedFolderId }) => {
    const users = Object.values(store.state.users || {})
        .filter((u) => u.main)
        .map((u) => ({ id: u.key, label: u.name }));
    form.setConfig({
        "title": "Add New Training Material",
        "type": "ignoreAutoAction",
        "fields": [...fields, {
            "label": "Users",
            "name": "UserIDs",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": users,
            "idKey": "id",
            "labelKey": "label"
        }],
        async postSubmitHook({ data, files }) {
            for (const userId of data.UserIDs || []) {
                if (!userId) continue;
                for (const file of files) {
                    if (!file[0]) continue;
                    const time = `-${new Date().getTime()}`;
                    await db.upload(`StaffTrainingRecords/${userId}/${time}`, file[0]);
                    await db.update(`Userdata/${userId}/Training/Records/${time}`, {
                        ...data,
                        "ID": time,
                        "Certificate": file[0].name,
                        "AddedBy": store.getters.userID,
                    })
                }
            };
        }
    });
    form.getDropdownData();
    form.toggle();
};

// export const completeTraining = ({ form, store, db, rowItem }) => {
//     const materials = Object.values(store.state["Home/TrainingMaterial"] || {})
//         .filter((m) => m.IncludeInMatrix)
//         .map((m) => ({ id: m.ID, label: m.Title }));

//     const users = Object.values(store.state.users || {})
//         .filter((u) => u.main)
//         .map((u) => ({ id: u.key, label: u.name }));

//     if (rowItem) {
//         form.setValues({
//             "MaterialID": rowItem.ID
//         });
//     }

//     form.setConfig({
//         "title": "Complete Training",
//         "type": "ignoreAutoAction",
//         "submitButtonLabel": "Mark Complete",
//         "fields": [{
//             "label": "Training Material",
//             "name": "MaterialID",
//             "type": "dropdown",
//             "dropdownData": materials,
//             "idKey": "id",
//             "labelKey": "label"
//         }, {
//             "label": "Users",
//             "name": "UserIDs",
//             "type": "dropdown",
//             "multiple": true,
//             "dropdownData": users,
//             "idKey": "id",
//             "labelKey": "label"
//         }, {
//             "label": "Date Completed",
//             "name": "DateCompleted",
//             "type": "date"
//         }],
//         async postSubmitHook({ data }) {
//             const materialId = data.MaterialID;
//             const dateCompleted = data.DateCompleted;
//             const userIds = Array.isArray(data.UserIDs) ? data.UserIDs : [data.UserIDs];
//             for (const userId of userIds) {
//                 if (!userId) continue;
//                 await db.update(`Home/TrainingMaterial/${materialId}/Users/${userId}`, {
//                     "Date": dateCompleted
//                 });
//             }
//         }
//     });

//     form.toggle();
// };


export const removeRecord = ({ form, pageItem, rowItem }) => {
    form.setConfig({
        "title": "Remove Training Record",
        "type": "delete",
        "description": "Are you sure you want to remove this record?",
        "location": `Userdata/${pageItem.Basic.key}/Training/Records/${rowItem.ID}`
    });

    form.toggle();
};

export const updateRecord = ({ form, pageItem, rowItem, store, db, router }) => {
    const date = (new Date()).toISOString();

    const recordValues = { ...rowItem };
    delete recordValues.Certificate;
    form.setValues({
        ...recordValues,
        "Date[Start]": rowItem?.Date?.Start,
        "Date[Complete]": rowItem?.Date?.Complete
    });

    form.setConfig({
        "title": "Revise Handbook",
        "location": `Userdata/${router?.currentRoute?.params.id}/Training/Records/${rowItem.ID}`,
        "type": "update",
        "fields": fields,

        async postSubmitHook({ files }) {
            for (const file of files) {

                if (!file[0]) continue;
                await db.upload(`StaffTrainingRecords/${router?.currentRoute?.params.id}/${rowItem.ID}`, file[0]);
                await db.update(`Userdata/${router?.currentRoute?.params.id}/Training/Records/${rowItem.ID}`, {
                    "Certificate": file[0].name,
                    "AddedBy": store.getters.userID,
                })
            };
        }
    });
    form.getDropdownData();

    form.toggle();
};

export const downloadCertificate = ({ pageItem, rowItem, db }) => {
    try {

        let rev = rowItem.Revision;
        // let url = await db.download()
        window.open(url, "__blank")
    } catch (err) {
        toast.error("Archive file found");
    }
};

export const addTrainingMaterial = ({ form, store, db, selectedFolderId }) => {
    form.setConfig({
        "title": "Add New Training Material",
        "type": "push",
        "description": "Home/TrainingMaterial",
        "location": "Home/TrainingMaterial",
        "fields": [{
            "label": "Title",
            "name": "Title",
            "type": "text"
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": false
        }, {
            "label": "Description",
            "name": "Description",
            "type": "text",
            "divClass": "md:col-span-3"
        }, {
            "label": "Mandatory",
            "name": "Mandatory",
            "type": "toggle",
            "required": false
        }, {
            "label": "Include in Training Matrix",
            "name": "IncludeInMatrix",
            "type": "toggle",
            "required": false
        }, {
            "label": "Valid Length (Months)",
            "name": "ValidLength",
            "type": "number",
            "required": false,
            show({ liveInputData }) { return !!liveInputData.IncludeInMatrix; }
        }],
        preSubmitHook() {
            return {
                "FolderID": selectedFolderId || null,
                "Date": {
                    "Added": (new Date()).toISOString(),
                    "AddedBy": store.getters.userID
                }
            };
        },
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                if (!file[0]) continue;
                await db.upload(`Database/TrainingMaterial/${typeRef.key}`, file[0]);
                await db.update(`Home/TrainingMaterial/${typeRef.key}`, {
                    "File": file[0].name
                })
            };
        }
    });

    form.toggle();
};

export const updateTrainingMaterial = ({ form, rowItem, db }) => {
    form.setValues({
        "Title": rowItem.Title,
        "Description": rowItem.Description,
        "Mandatory": rowItem.Mandatory || false,
        "IncludeInMatrix": rowItem.IncludeInMatrix || false,
        "ValidLength": rowItem.ValidLength || null
    });
    form.setConfig({
        "title": "Edit Training Material",
        "type": "update",
        "location": `Home/TrainingMaterial/${rowItem.ID}`,
        "fields": [{
            "label": "Title",
            "name": "Title",
            "type": "text"
        }, {
            "label": "File",
            "name": "File",
            "type": "file"
        }, {
            "label": "Description",
            "name": "Description",
            "type": "text",
            "divClass": "md:col-span-3"
        }, {
            "label": "Mandatory",
            "name": "Mandatory",
            "type": "toggle",
            "required": false
        }, {
            "label": "Include in Training Matrix",
            "name": "IncludeInMatrix",
            "type": "toggle",
            "required": false
        }, {
            "label": "Valid Length (Months)",
            "name": "ValidLength",
            "type": "number",
            "required": false,
            "divClass": "md:col-span-2",
            show(f) { return !!f.IncludeInMatrix; }
        }],
        async postSubmitHook({ files }) {
            for (const file of files) {
                if (!file[0]) continue;
                await db.upload(`Database/TrainingMaterial/${rowItem.ID}`, file[0]);
                await db.update(`Home/TrainingMaterial/${rowItem.ID}`, {
                    "File": file[0].name
                })
            };
        }
    });

    form.toggle();
}

// --- Folder CRUD actions ---

export const createFolder = ({ form, selectedFolderId }) => {
    form.setConfig({
        "title": "Create Folder",
        "type": "push",
        "location": "Home/TrainingMaterialFolders",
        "fields": [{
            "label": "Folder Name",
            "name": "Name",
            "type": "text"
        }, {
            "label": "Description",
            "name": "Description",
            "type": "text",
            "required": false,
            "divClass": "md:col-span-2"
        }],
        preSubmitHook() {
            return {
                "Parent": selectedFolderId || null
            };
        }
    });

    form.toggle();
};

export const updateFolder = ({ form, selectedFolder }) => {
    form.setValues({
        "Name": selectedFolder.Name,
        "Description": selectedFolder.Description || ""
    });
    form.setConfig({
        "title": "Update Folder",
        "type": "update",
        "location": `Home/TrainingMaterialFolders/${selectedFolder.ID}`,
        "fields": [{
            "label": "Folder Name",
            "name": "Name",
            "type": "text"
        }, {
            "label": "Description",
            "name": "Description",
            "type": "text",
            "required": false,
            "divClass": "md:col-span-2"
        }]
    });

    form.toggle();
};

export const deleteFolder = ({ form, selectedFolder, allFolders, store, toast }) => {
    const hasChildren = (allFolders || []).some((f) => f.Parent === selectedFolder.ID);
    const items = store.state["Home/TrainingMaterial"];
    const hasItems = items && Object.values(items).some((i) => i.FolderID === selectedFolder.ID);

    if (hasChildren || hasItems) {
        toast.error("Cannot delete a folder that contains items or subfolders. Move or remove them first.");
        return;
    }

    form.setConfig({
        "title": "Delete Folder",
        "type": "delete",
        "description": `Are you sure you want to delete the folder "${selectedFolder.Name}"?`,
        "location": `Home/TrainingMaterialFolders/${selectedFolder.ID}`
    });

    form.toggle();
};
